import "../../css/pageLayout.css"
import { parseJsonField } from "../../utils/parseJsonField";

function DownloadsSection({ section }) {
  const settings = parseJsonField(section.settings_json);
  const items = section.items || [];

  return (
    <section className="downloads-section">
      {settings.title && <h3>{settings.title}</h3>}
      {settings.description && <p>{settings.description}</p>}

      <ul>
        {items
          .filter((item) => item.is_visible !== false)
          .map((item) => {
            const content = parseJsonField(item.content_json);

            return (
              <li key={item.id} className="download-item">
                <strong>{content.label}</strong>

                {content.description && <p>{content.description}</p>}

                {content.file_url ? (
                  <a href={content.file_url} download>
                    Download
                  </a>
                ) : (
                  <span>File ID: {content.file_id}</span>
                )}
              </li>
            );
          })}
      </ul>
    </section>
  );
}

export default DownloadsSection;